/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { APP_BASE_HREF } from "@angular/common";
import { BrowserModule } from "@angular/platform-browser";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { ElementRef, NgModule, CUSTOM_ELEMENTS_SCHEMA } from "@angular/core";
import { HttpClientModule } from "@angular/common/http";
import { CoreModule } from "./@core/core.module";
import { Ng2SmartTableModule } from "ng2-smart-table";

import { AppComponent } from "./app.component";
import { AppRoutingModule } from "./app-routing.module";
import { ThemeModule } from "./@theme/theme.module";
import { NgbActiveModal, NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { AuthModule } from "./auth/auth.module";

import { MasterService } from "./shared/services/master.service";
import { SitesService } from "./shared/services/sites.service";
import { AuthService } from "./shared/services/auth.service";
import { ServersService } from "./shared/services/servers.service";
import { CheckpointServersService} from "./shared/services/checkpoint-server.service";
import { DataService } from "./shared/services/data.service";
import { SensorsService } from "./shared/services/sensors.service";
import { AgmCoreModule } from "@agm/core";
import {
  NbThemeModule,
  NbMenuModule,
  NbDialogConfig,
  NbDialogService,
} from "@nebular/theme";
import { AuthGuard } from "./auth-guard.service";
import { FormsModule } from "@angular/forms";
import { GoogleChartsModule } from "angular-google-charts";
import { CreateSensorComponent } from "./pages/sensors/create-sensor/create-sensor.component";
import { LbaRemoteComponent } from "./pages/overview/sensors/lba-remote.component";
import { setSsidComponent } from "./pages/sensors/change-ssid/change-ssid.component";
import { CaptivePortalComponent } from "./pages/sensors/captive-portal/captive-portal.component";
// import { NavbarComponent } from './navbar/navbar.component';
import {
  NbMenuService,
  NbWindowModule,
  NbCheckboxModule,
  NbMenuItem,
  NbLayoutModule,
  NbDialogModule,
} from "@nebular/theme";

@NgModule({
  declarations: [
    AppComponent,
    CreateSensorComponent,
    setSsidComponent,
    CaptivePortalComponent,
    // NavbarComponent,
    // LbaRemoteComponent,
  ],
  entryComponents: [
    CreateSensorComponent,
    setSsidComponent,
    CaptivePortalComponent,
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    AppRoutingModule,
    Ng2SmartTableModule,
    NbLayoutModule,
    NbMenuModule,
    NbCheckboxModule,
    NbWindowModule.forRoot(),
    NgbModule,
    NbMenuModule.forRoot(),
    NbDialogModule.forChild(),
    ThemeModule.forRoot(),
    CoreModule.forRoot(),
    GoogleChartsModule.forRoot("AIzaSyDYrwf31HPm04Ej3Ydjg04YZXxjaCs22ro"),

    AuthModule,
    FormsModule,

    AgmCoreModule.forRoot({
      apiKey: "AIzaSyDYrwf31HPm04Ej3Ydjg04YZXxjaCs22ro",
      language: "en",
      libraries: ["places"],
    }),
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  // exports: [ CreateSensorComponent],
  bootstrap: [AppComponent],
  providers: [
    AuthService,
    AuthGuard,
    MasterService,
    SitesService,
    ServersService,
    CheckpointServersService,
    DataService,
    SensorsService,
    NgbActiveModal,
    { provide: APP_BASE_HREF, useValue: "/" },
  ],
})
export class AppModule {}
